import React, { useState, useEffect } from 'react';
import SectionTitle from '../Common/SectionTitle';

const ContactInfo = (props) => {
    const { contactBoxClass } = props;

    // State to hold the contact data
    const [contactData, setContactData] = useState(null);

    // Fetch data from the API
    useEffect(() => {
        fetch('https://yautiktechnology.com/api/contact_us')
            .then(response => response.json())
            .then(data => {
                if (data && data.length > 0) {
                    setContactData(data[0]); // Set the contact data to state
                }
            })
            .catch(error => console.error('Error fetching contact data:', error));
    }, []);

    // If contact data is not yet available, return loading or empty state
    if (!contactData) {
        return <div>Loading...</div>;
    }

    return (
        <div className={contactBoxClass ? contactBoxClass : 'contact-box'}>
            <SectionTitle
                sectionClass="sec-title mb-44"
                subtitleClass="sub-text new-text white-color"
                subtitle="Let's Talk"
                titleClass="title white-color"
                title={contactData.heading} // Dynamically use the heading from the API response
            />
            <div className="address-box mb-24">
                <div className="address-icon">
                    <i className="fa fa-phone"></i>
                </div>
                <div className="address-text">
                    <span className="label">Phone:</span>
                    <a href={`tel:${contactData.phoneNumber}`}>{contactData.phoneNumber}</a>
                </div>
            </div>
            <div className="address-box mb-24">
                <div className="address-icon">
                    <i className="fa fa-home"></i>
                </div>
                <div className="address-text">
                    <span className="label">Email:</span>
                    <a href={`mailto:${contactData.email}`}>{contactData.email}</a>
                </div>
            </div>
            <div className="address-box">
                <div className="address-icon">
                    <i className="fa fa-map-marker"></i>
                </div>
                <div className="address-text">
                    <span className="label">Address:</span>
                    <div className="desc">{contactData.address}</div>
                </div>
            </div>
        </div>
    );
};

export default ContactInfo;
